import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Uploader as ApiUploader } from '@citrite/sf-api';
var _StyleSheet$create = StyleSheet.create({
    inputStyles: {
      height: '0',
      width: '0',
      visibility: 'hidden',
      position: 'absolute'
    }
  }),
  inputStyles = _StyleSheet$create.inputStyles;
export var Html5Uploader = /*#__PURE__*/function (_React$Component) {
  function Html5Uploader() {
    var _this;
    _classCallCheck(this, Html5Uploader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Html5Uploader, [].concat(args));
    _defineProperty(_this, "fileInput", void 0);
    _defineProperty(_this, "handleRef", function (input) {
      return _this.fileInput = input;
    });
    _defineProperty(_this, "inputSelectorChangeEvent", function (event) {
      ApiUploader.parseItems(event.currentTarget).then(function (items) {
        var _this$props;
        if (!items || items.length === 0) {
          return;
        }
        (_this$props = _this.props).onAddItems.apply(_this$props, _toConsumableArray(items));
      });
    });
    return _this;
  }
  _inherits(Html5Uploader, _React$Component);
  return _createClass(Html5Uploader, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("input", {
        id: this.props.id,
        className: css(inputStyles),
        ref: this.handleRef,
        onChange: this.inputSelectorChangeEvent,
        type: "file",
        value: "",
        accept: (this.props.fileOrMimeTypes || []).join(','),
        multiple: !this.props.forceSingleFile
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.showNativeFileBrowser && !prevProps.showNativeFileBrowser) {
        this.fileInput.click();
        this.props.resetNativeFileBrowserState(); // do this to clear showNativeFileBrowser state so we don't fire multiple times after clicking cancel
      }
    }
  }]);
}(React.Component);